export default __webpack_public_path__ + "static/media/101-logo.c3f04158.svg";